<div class="modal-header">
  <h4 id="confirmation-dialog-modal" class="modal-title">
    {{ title || "Are you sure?" | translate }}
  </h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p *ngIf="showMessage" [innerHTML]="message || 'This operation requires an additional confirmation.' | translate"></p>

  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.dismiss()"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button [class.loading]="loadingService.loading$ | async" (click)="close()" class="btn btn-primary" type="button">
    {{ "Yes, continue" | translate }}
  </button>
</div>
